module.exports = __webpack_public_path__ + "media/images/products/retailers-ecommerce-2-sample01-ef505404305c3f22faad4b828756ae14.jpg";